if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.payNowButton = this.querySelector('[data-fere-pay-now]');
        this.requestInFlight = false;
        this.checkoutRedirecting = false;
        if (this.payNowButton) {
          this.payNowObserver = new MutationObserver(() => this.syncPayNowButton());
          this.onPageShow = (event) => {
            if (!event.persisted) return;
            this.requestInFlight = false;
            this.checkoutRedirecting = false;
            this.checkoutForm?.remove();
            this.submitButton.removeAttribute('aria-disabled');
            [this.submitButton, this.payNowButton].forEach((button) => {
              button.classList.remove('loading');
              button.querySelector('.loading__spinner')?.classList.add('hidden');
            });
            this.syncPayNowButton();
          };
        }
        this.appraisalInput = this.querySelector('[data-fere-appraisal]');
        this.appraisalVariantId = this.dataset.appraisalVariantId || '';
        this.appraisalStorageKey = this.dataset.productHandle
          ? `fereAppraisal:${this.dataset.productHandle}`
          : '';

        if (this.appraisalInput && this.appraisalStorageKey) {
          try {
            this.appraisalInput.checked = window.sessionStorage.getItem(this.appraisalStorageKey) === 'true';
          } catch (error) {}
          this.appraisalInput.addEventListener('change', () => {
            try {
              window.sessionStorage.setItem(this.appraisalStorageKey, this.appraisalInput.checked ? 'true' : 'false');
            } catch (error) {}
          });
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        if (!this.payNowObserver) return;
        this.payNowObserver.observe(this.submitButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
        this.payNowObserver.observe(this.variantIdInput, { attributes: true, attributeFilter: ['value', 'disabled'] });
        const root = this.closest('product-info');
        if (root) this.payNowObserver.observe(root, { attributes: true, attributeFilter: ['data-fere-purchase-locked'] });
        window.addEventListener('pageshow', this.onPageShow);
        this.syncPayNowButton();
      }

      disconnectedCallback() {
        this.payNowObserver?.disconnect();
        if (this.onPageShow) window.removeEventListener('pageshow', this.onPageShow);
      }

      syncPayNowButton() {
        if (!this.payNowButton) return;
        const locked = this.closest('product-info')?.dataset.ferePurchaseLocked !== 'false';
        const disabled = locked || this.requestInFlight || this.checkoutRedirecting
          || !/^[1-9]\d*$/.test(this.variantIdInput.value || '')
          || this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true';
        this.payNowButton.disabled = disabled;
        this.payNowButton.setAttribute('aria-disabled', String(disabled));
      }

      proceedToCheckout() {
        this.checkoutRedirecting = true;
        this.syncPayNowButton();
        this.checkoutForm = document.createElement('form');
        this.checkoutForm.method = 'post';
        this.checkoutForm.action = window.routes.cart_url;
        this.checkoutForm.hidden = true;
        const checkout = document.createElement('input');
        checkout.type = 'hidden';
        checkout.name = 'checkout';
        checkout.value = 'Checkout';
        this.checkoutForm.append(checkout);
        document.body.append(this.checkoutForm);
        this.checkoutForm.submit();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const checkoutRequested = evt.submitter === this.payNowButton && Boolean(this.payNowButton);
        if (this.requestInFlight || this.checkoutRedirecting || this.submitButton.disabled
          || this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.form.reportValidity()) return;
        if (checkoutRequested) {
          this.syncPayNowButton();
          if (this.payNowButton.disabled) return;
        }

        this.handleErrorMessage();

        this.requestInFlight = true;
        this.submitButton.setAttribute('aria-disabled', true);
        this.syncPayNowButton();
        const activeButton = checkoutRequested ? this.payNowButton : this.submitButton;
        const activeSpinner = activeButton.querySelector('.loading__spinner');
        activeButton.classList.add('loading');
        activeSpinner?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = new FormData(this.form);
        const appraisalSelected = Boolean(
          this.appraisalInput?.checked && /^\d+$/.test(this.appraisalVariantId)
        );
        const configurationId = appraisalSelected
          ? `FERE-${Date.now()}-${window.crypto?.randomUUID?.() || Math.random().toString(36).slice(2)}`
          : '';
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        if (appraisalSelected) {
          const properties = {};
          formData.forEach((value, key) => {
            if (!key.startsWith('properties[') || !key.endsWith(']') || value === '') return;
            properties[key.slice(11, -1)] = value;
          });
          properties['_FERE Configuration ID'] = configurationId;

          const requestBody = {
            items: [
              {
                id: Number(variantId),
                quantity,
                properties,
              },
              {
                id: Number(this.appraisalVariantId),
                quantity: 1,
                properties: {
                  'Appraisal for': this.dataset.productTitle || 'FERE jewelry',
                  '_FERE Linked Configuration': configurationId,
                  '_FERE Service': 'full-piece-appraisal',
                },
              },
            ],
          };
          if (this.cart) {
            requestBody.sections = this.cart.getSectionsToRender().map((section) => section.id);
            requestBody.sections_url = window.location.pathname;
          }
          config.body = JSON.stringify(requestBody);
        } else {
          delete config.headers['Content-Type'];
          config.body = formData;
        }
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (checkoutRequested) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              this.proceedToCheckout();
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            if (appraisalSelected && this.appraisalInput) {
              this.appraisalInput.checked = false;
              try { window.sessionStorage.removeItem(this.appraisalStorageKey); } catch (error) {}
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.checkoutRedirecting = false;
            this.checkoutForm?.remove();
            this.handleErrorMessage(window.cartStrings?.error || e.message);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.requestInFlight = false;
            activeButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && !this.checkoutRedirecting) this.submitButton.removeAttribute('aria-disabled');
            activeSpinner?.classList.add('hidden');
            this.syncPayNowButton();

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
